import { createContext } from 'react';

import { OrderStatusReason } from 'enums';
import {
  Bank,
  Currency,
  Merchant,
  PaymentType,
  User,
  TradeMethod,
  Meta,
  CurrencyExchange,
  SciDomain,
  P2PProviderSummary,
  AssetCurrencyExchange,
  SidebarHeaderConfig,
  Cascade,
} from 'types';

export type AccountNumberQrSupportedCombination = {
  currencyCode: string;
  paymentType: string;
};

export type UserContextProps = {
  user: User;
  merchant?: Merchant;
  fiatCurrencies: Currency[];
  assetCurrencies: Currency[];
  banks: Bank[];
  banksRaw: Bank[];
  sidebarHeaderConfig: SidebarHeaderConfig;
  paymentTypes: PaymentType[];
  tradeMethods: TradeMethod[];
  orderStatusReasons: OrderStatusReason[];
  disputeCompletedStatusReasons: OrderStatusReason[];
  allTradeMethods: TradeMethod[];
  currencyExchanges: CurrencyExchange[];
  meta: Meta[];
  sciDomains: SciDomain[];
  p2pProviders: P2PProviderSummary[];
  assetCurrencyExchange: AssetCurrencyExchange[];
  cascades: Cascade[];
};

export const UserContext = createContext<UserContextProps>(
  {} as UserContextProps,
);
